import styled from 'styled-components';

import media from '../../utils/mediaQueries';
import { NOTES_COLOR, PALE_GREY } from '../../theme';

const Badge = styled.div`
  border-radius: 12px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
`;

const PageBadge = styled(Badge)`
  padding: 24px 40px 40px;
  margin-bottom: 40px;

  ${media.mobile`
    padding: 16px 24px 24px;
  `}
`;

const BadgeHeader = styled.div`
  margin: 0 -40px;
  padding: 0 40px 24px;
  border-bottom: 1px solid ${PALE_GREY};

  ${media.mobile`
    margin: 0 -24px;
    padding: 0 24px 24px;
  `}
`;

const BadgeTitle = styled.h2`
  font-size: 32px;
  font-weight: 800;
  letter-spacing: 0.2px;
  margin: 0;

  ${media.mobile`
    font-size: 24px;
  `}
`;

const BadgeSubtitle = styled.p`
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: ${NOTES_COLOR};
  margin: 8px 0 0;
`;

const BadgeBody = styled.div`
  font-size: 18px;
  padding-top: 24px;

  ${media.mobile`
    padding-top: 8px;
  `}
`;

export {
  Badge, PageBadge, BadgeTitle, BadgeSubtitle, BadgeBody, BadgeHeader,
};
